import React, { useState } from 'react';

const Home = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    message: '',
    interests: [],
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData((prevData) => {
        const newInterests = checked
          ? [...prevData.interests, value]
          : prevData.interests.filter((interest) => interest !== value);
        return { ...prevData, interests: newInterests };
      });
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.fullName) {
      newErrors.fullName = 'Full Name is required';
    }
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email address is invalid';
    }
    if (!formData.message) {
      newErrors.message = 'Message is required';
    }
    if (formData.interests.length === 0) {
      newErrors.interests = 'Please select at least one interest';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    if (validateForm()) {
      console.log('Form data submitted:', formData);
      // Here you would typically send the data to a server
      alert('Form submitted successfully!');
      setFormData({
        fullName: '',
        email: '',
        message: '',
        interests: [],
      });
      setErrors({});
      setIsSubmitting(false);
    } else {
      setIsSubmitting(false);
    }
  };

  return (
    <main id="home" className="w-full relative z-10">
      {/* Hero Section */}
      <section className="w-full bg-coffee-light relative z-0">
        <div className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="flex flex-col justify-center gap-6 text-center lg:text-left">
            <h1 className="font-serif text-3xl lg:text-4xl font-semibold text-coffee-dark leading-tight tracking-tight">Coffee First, then the world...</h1>
            <h2 className="font-serif text-2xl text-coffee-dark">The rich taste of Ugandan coffee crafted through dedication, experience, and innovation</h2>
            <p className="mt-2 text-sm text-gray-600">
              Established in 2019, Funzo Coffee Limited is a Ugandan coffee company inspired by the Swahili word Mafunzo, meaning lessons. From trading green coffee beans to championing value addition, Funzo Coffee is redefining Uganda’s position in the global coffee value chain.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a href="/about" className="px-6 py-3 bg-coffee-primary text-white rounded-lg shadow-md transition-all duration-150 hover:bg-coffee-dark hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-coffee-accent">Explore Our Story</a>
              <a href="/contact" className="inline-flex items-center gap-2 px-6 py-3 border border-gray-300 rounded-lg text-coffee-primary transition-colors duration-200 hover:text-coffee-secondary hover:border-coffee-secondary focus:outline-none focus:ring-2 focus:ring-coffee-accent">
                <img src="https://api.iconify.design/lucide-leaf.svg?color=%235C3A21" alt="Leaf icon" className="w-5 h-5"/>
                <span>Partner With Us</span>
              </a>
            </div>
            <div className="flex items-center justify-center lg:justify-start gap-3 pt-2 mt-4 ">
              <span className="inline-block w-2 h-2 rounded-full bg-coffee-secondary"></span>
              <span className="text-sm text-gray-600">Rooted in Uganda’s rich terroir | Fair, traceable, value-driven</span>
            </div>
          </div>
          <div className="relative rounded-xl overflow-hidden shadow-xl">
            <img src="/images/B69A1405.jpg" alt="Ugandan coffee farm landscape" className="w-full h-96 object-cover"/>
            <div className="absolute inset-0 bg-gradient-to-t from-orange-50/70 to-transparent"></div>
            <div className="absolute bottom-4 left-4 bg-white/85 backdrop-blur-sm px-4 py-2 rounded-md flex items-center gap-2">
              <img src="https://api.iconify.design/lucide-map-pin.svg?color=%235C3A21" alt="Map pin" className="w-4 h-4"/>
              <span className="text-sm text-gray-700">Coffee Growers Highlands, Eastern Uganda</span>
            </div>
          </div>
        </div>
      </section>

      {/* About Highlight */}
      <section className="w-full bg-orange-50 border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-6 py-12">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6">
            <div className="flex flex-col gap-2">
              <h2 className="font-serif text-4xl text-coffee-dark">About Highlight</h2>
              <p className="mt-2 text-sm text-gray-600">
                From trading green coffee beans to championing value addition</p>
            </div>
            <a href="/about" className="inline-flex items-center gap-2 text-coffee-secondary hover:text-green-700 focus:outline-none focus:ring-2 focus:ring-coffee-secondary">
              <img src="https://api.iconify.design/lucide-book-open.svg?color=%233F7C3A" alt="Book icon" className="w-5 h-5"/>
              <span>Learn More</span>
            </a>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-8 ">
            <div className="block p-5 bg-white rounded-xl shadow-sm transition-all duration-300 hover:translate-y-[-5px] hover:shadow-md focus:outline-none focus:ring-2 focus:ring-coffee-secondary border border border-blue-200">
              <div className="flex items-center gap-3">
                <img src="https://api.iconify.design/lucide-leaf.svg?color=%235C3A21" alt="Leaf icon" className="w-6 h-6"/>
                <span className="font-semibold text-coffee-primary">Over 5 years </span>
                
              </div>
              <p className="mt-2 text-sm text-gray-600">Over 5 years of excellence in the coffee industry</p>
             
            </div>
            <div className="block p-5 bg-white rounded-xl shadow-sm transition-all duration-300 hover:translate-y-[-5px] hover:shadow-md focus:outline-none focus:ring-2 focus:ring-2 focus:ring-coffee-secondary border border border-blue-200">
              <div className="flex items-center gap-3">
                <img src="https://api.iconify.design/lucide-globe.svg?color=%235C3A21" alt="Globe icon" className="w-6 h-6"/>
                <span className="font-semibold text-coffee-primary">Presence </span>
              </div>
              <p className="mt-2 text-sm text-gray-600">Globally present across GCC, Europe, North America & Canada</p>
             
            </div>
            <div className="block p-5 bg-white rounded-xl shadow-sm transition-all duration-300 hover:translate-y-[-5px] hover:shadow-md focus:outline-none focus:ring-2 focus:ring-2 focus:ring-coffee-secondary border border border-blue-200">
              <div className="flex items-center gap-3">
                <img src="https://api.iconify.design/lucide-coffee.svg?color=%235C3A21" alt="Coffee icon" className="w-6 h-6"/>
                <span className="font-semibold text-coffee-primary">Partnership</span>
              </div>
              <p className="mt-2 text-sm text-gray-600">Partner in the Uganda Coffee Value Addition Project</p>
             
            </div>
            <div className="block p-5 bg-white rounded-xl shadow-sm transition-all duration-300 hover:translate-y-[-5px] hover:shadow-md focus:outline-none focus:ring-2 focus:ring-2 focus:ring-coffee-secondary border border border-blue-200">
              <div className="flex items-center gap-3">
                <img src="https://api.iconify.design/lucide-handshake.svg?color=%235C3A21" alt="Handshake icon" className="w-6 h-6"/>
                <span className="font-semibold text-coffee-primary">Support</span>
              </div>
              <p className="mt-2 text-sm text-gray-600">Supported by PACEID in market expansion to China</p>
             
            </div>
          </div>
        </div>
      </section>

      {/* Quality Commitment Section */}
      <section className="w-full bg-white">
        <div className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="rounded-xl overflow-hidden shadow-xl">
            <img loading="lazy" src="https://app.grapesjs.com/api/assets/random-image?query=%22coffee%20processing%22&w=1200&h=800" alt="Coffee processing and quality control" className="w-full h-96 object-cover"/>
          </div>
          <div className="flex flex-col gap-5">
            <h2 className="font-serif text-4xl text-coffee-dark">Committed to Quality & Value Addition</h2>
            <p className="mt-2 text-sm text-gray-600">
              We partner directly with Ugandan farmers and cooperatives, applying rigorous standards from cherry selection to post-harvest handling. Our value addition unlocks flavor, increases farmer incomes, and elevates Uganda’s global reputation.
            </p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {/* <li className="flex items-start gap-3 p-4 bg-orange-50 rounded-xl"> */}
              <li className="flex items-start gap-3 p-4 bg-orange-50 rounded-xl border border border-blue-200">
                <img src="https://api.iconify.design/lucide-shield-check.svg?color=%233F7C3A" alt="Shield check" className="w-5 h-5 mt-1"/>
                <div className="flex flex-col gap-1">
                  <span className="font-semibold text-coffee-primary">Certified Quality Controls</span>
                  <span className="text-sm text-gray-600">Strict cupping protocols, moisture and defect standards.</span>
                </div>
              </li>
             <li className="flex items-start gap-3 p-4 bg-orange-50 rounded-xl border border border-blue-200">
                <img src="https://api.iconify.design/lucide-hammer.svg?color=%233F7C3A" alt="Hammer icon" className="w-5 h-5 mt-1"/>
                <div className="flex flex-col gap-1">
                  <span className="font-semibold text-coffee-primary">Value-Added Processing</span>
                  <span className="text-sm text-gray-600">Washed, natural, honey, and carefully developed roast profiles.</span>
                </div>
              </li>
             <li className="flex items-start gap-3 p-4 bg-orange-50 rounded-xl border border border-blue-200">
                <img src="https://api.iconify.design/lucide-route.svg?color=%233F7C3A" alt="Route icon" className="w-5 h-5 mt-1"/>
                <div className="flex flex-col gap-1">
                  <span className="font-semibold text-coffee-primary">Traceability</span>
                  <span className="text-sm text-gray-600">Lot-level tracking from farm to export.</span>
                </div>
              </li>
             <li className="flex items-start gap-3 p-4 bg-orange-50 rounded-xl border border border-blue-200">
                <img src="https://api.iconify.design/lucide-leaf.svg?color=%233F7C3A" alt="Leaf icon" className="w-5 h-5 mt-1"/>
                <div className="flex flex-col gap-1">
                  <span className="font-semibold text-coffee-primary">Sustainable Practices</span>
                  <span className="text-sm text-gray-600">Soil health, shade-grown, and community training.</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="w-full bg-orange-50 border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-6 py-12">
          <div className="flex flex-col gap-2 mb-8">
            <h2 className="font-serif text-4xl text-coffee-dark">Trusted by Partners & Customers</h2>
            <p className="mt-2 text-sm text-gray-600">Voices from the value chain</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="p-5 bg-white rounded-2xl shadow-sm border border-gray-200 flex flex-col gap-5 items-start transition-all duration-300 hover:translate-y-[-5px] hover:shadow-md border border border-blue-200">
              <div className="flex items-center gap-3">
                <img loading="lazy" src="https://app.grapesjs.com/api/assets/random-image?query=%22person%20portrait%22&w=120&h=120" alt="Partner portrait" className="w-14 h-14 rounded-full object-cover border border-gray-200"/>
                <div className="flex flex-col">
                  <span className="font-semibold text-coffee-primary">Amina — Cooperative Lead</span>
                  <span className="text-xs text-gray-600">Mbale, Uganda</span>
                </div>
              </div>
              <p className="mt-2 text-sm text-gray-600">“Funzo has transformed our post-harvest practices. Our farmers earn more, and our coffees cup cleaner every season.”</p>
            </div>
            <div className="p-5 bg-white rounded-2xl shadow-sm border border-gray-200 flex flex-col gap-5 items-start transition-all duration-300 hover:translate-y-[-5px] hover:shadow-md border border border-blue-200">
              <div className="flex items-center gap-3">
                <img loading="lazy" src="https://app.grapesjs.com/api/assets/random-image?query=%22barista%22&w=120&h=120" alt="Barista portrait" className="w-14 h-14 rounded-full object-cover border border-gray-200"/>
                <div className="flex flex-col">
                  <span className="font-semibold text-coffee-primary">Daniel — Roastery Buyer</span>
                  <span className="text-xs text-gray-600">Hamburg, Germany</span>
                </div>
              </div>
              <p className="mt-2 text-sm text-gray-600">“Consistent lot quality and transparent sourcing make Funzo a reliable partner for our specialty lineup.”</p>
            </div>
            <div className="p-5 bg-white rounded-2xl shadow-sm border border-gray-200 flex flex-col gap-5 items-start transition-all duration-300 hover:translate-y-[-5px] hover:shadow-md border border border-blue-200">
              <div className="flex items-center gap-3">
                <img loading="lazy" src="https://app.grapesjs.com/api/assets/random-image?query=%22smiling%20customer%22&w=120&h=120" alt="Customer portrait" className="w-14 h-14 rounded-full object-cover border border-gray-200"/>
                <div className="flex flex-col">
                  <span className="font-semibold text-coffee-primary">Grace — Café Owner</span>
                  <span className="text-xs text-gray-600">Kampala, Uganda</span>
                </div>
              </div>
              <p className="mt-2 text-sm text-gray-600">“Our customers love the origin stories and the vibrant Ugandan profiles Funzo selects.”</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="w-full bg-white border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="flex flex-col gap-5">
            <h2 className="font-serif text-4xl text-coffee-dark">Our Story: Learning with Mafunzo</h2>
            <p className="mt-2 text-sm text-gray-600">
              Inspired by the Swahili word “Mafunzo”, Funzo Coffee embraces continuous learning across the supply chain. We started trading green beans to connect Uganda’s smallholders with global markets, and expanded into value addition to amplify quality and impact.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="p-5 bg-orange-50 rounded-xl shadow-inner flex items-start gap-3 border border border-blue-200">
                <img src="https://api.iconify.design/lucide-earth.svg?color=%235C3A21" alt="Earth icon" className="w-6 h-6 mt-0.5"/>
                <div className="flex flex-col gap-1">
                  <span className="font-semibold text-coffee-dark">Origin Pride</span>
                  <span className="text-sm text-gray-600">Showcasing Uganda’s terroirs—from Rwenzori to Mt. Elgon.</span>
                </div>
              </div>
              <div className="p-5 bg-orange-50 rounded-xl shadow-inner flex items-start gap-3 border border border-blue-200">
                <img src="https://api.iconify.design/lucide-users.svg?color=%235C3A21" alt="Users icon" className="w-6 h-6 mt-0.5"/>
                <div className="flex flex-col gap-1">
                  <span className="font-semibold text-coffee-dark">Community First</span>
                  <span className="text-sm text-gray-600">Training, fair premiums, and inclusive partnerships.</span>
                </div>
              </div>
            </div>
            <a href="/value" className="inline-flex items-center gap-2 text-coffee-secondary hover:text-green-700 focus:outline-none focus:ring-2 focus:ring-coffee-secondary">
              <img src="https://api.iconify.design/lucide-arrow-right.svg?color=%233F7C3A" alt="Arrow icon" className="w-5 h-5"/>
              <span>See our value addition approach</span>
            </a>
          </div>
          <div className="rounded-xl overflow-hidden shadow-xl">
            <img loading="lazy" src="/images/Coffee-Roasting.jpg" alt="Ugandan cultural tapestry" className="w-full h-96 object-cover"/>
          </div>
        </div>
      </section>

      {/* Our Coffee Section */}
      <section id="coffee" className="w-full bg-orange-50">
        <div className="max-w-6xl mx-auto px-6 py-16">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6">
            <div className="flex flex-col gap-2">
              <h2 className="font-serif text-4xl text-coffee-dark">Our Coffee: Green to Roasted</h2>
              <p className="mt-2 text-sm text-gray-600">Select lots, transparent sourcing, curated profiles</p>
            </div>
            <a href="/contact" className="inline-flex items-center gap-2 text-coffee-secondary hover:text-green-700 focus:outline-none focus:ring-2 focus:ring-coffee-secondary">
              <img src="https://api.iconify.design/lucide-file-text.svg?color=%233F7C3A" alt="File icon" className="w-5 h-5"/>
              <span>Request current lot sheet</span>
            </a>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
            <div className="bg-white rounded-xl shadow-sm overflow-hidden flex flex-col transition-all duration-300 hover:translate-y-[-5px] hover:shadow-md">
              <img loading="lazy" src="/images/green_coffee.jpg" alt="Green coffee beans" className="w-full h-56 object-cover"/>
              <div className="p-5 flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <img src="https://api.iconify.design/lucide-bean.svg?color=%235C3A21" alt="Bean icon" className="w-5 h-5"/>
                  <span className="font-semibold text-coffee-dark">Green Beans</span>
                </div>
                <p className="mt-2 text-sm text-gray-600">Lot selection from Rwenzori and Mt. Elgon; graded to export standards.</p>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm overflow-hidden flex flex-col transition-all duration-300 hover:translate-y-[-5px] hover:shadow-md">
              <img loading="lazy" src="/images/q.jpg" alt="Coffee roasting" className="w-full h-56 object-cover"/>
              <div className="p-5 flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <img src="https://api.iconify.design/lucide-flame.svg?color=%235C3A21" alt="Flame icon" className="w-5 h-5"/>
                  <span className="font-semibold text-coffee-dark">Roasted Profiles</span>
                </div>
                <p className="mt-2 text-sm text-gray-600">Medium to light roast development to highlight fruit-forward Ugandan notes.</p>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm overflow-hidden flex flex-col transition-all duration-300 hover:translate-y-[-5px] hover:shadow-md">
              <img loading="lazy" src="/images/coffee.jpg" alt="Coffee cupping" className="w-full h-56 object-cover"/>
              <div className="p-5 flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <img src="https://api.iconify.design/lucide-trophy.svg?color=%235C3A21" alt="Trophy icon" className="w-5 h-5"/>
                  <span className="font-semibold text-coffee-dark">Specialty Lots</span>
                </div>
                <p className="mt-2 text-sm text-gray-600">Micro-lots with unique processing: honey and anaerobic naturals.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Value Addition Section */}
        <section id="value" className="w-full bg-gradient-to-br from-[#fefefeff] to-[#F5EFE6] py-16 border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="flex flex-col gap-5">
            <h2 className="font-serif text-4xl text-coffee-dark">Value Addition: Elevating Uganda’s Coffee</h2>
            <p className="mt-2 text-sm text-gray-600">
              Our approach integrates farmer training, selective processing, and market-driven roasting to create distinctive Ugandan profiles that stand out globally.
            </p>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <img src="https://api.iconify.design/lucide-check-circle.svg?color=%233F7C3A" alt="Check icon" className="w-5 h-5 mt-0.5"/>
                <div className="flex flex-col">
                  <span className="font-semibold text-coffee-dark">Farmer Training & Mafunzo Sessions</span>
                  <span className="text-sm text-gray-600">Selective picking, fermentation control, and drying best practices.</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <img src="https://api.iconify.design/lucide-scale.svg?color=%233F7C3A" alt="Scale icon" className="w-5 h-5 mt-0.5"/>
                <div className="flex flex-col">
                  <span className="font-semibold text-coffee-dark">Quality Grading & Cupping</span>
                  <span className="text-sm text-gray-600">Defect sorting, moisture targets, and sensory evaluation.</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <img src="https://api.iconify.design/lucide-thermometer.svg?color=%233F7C3A" alt="Thermometer icon" className="w-5 h-5 mt-0.5"/>
                <div className="flex flex-col">
                  <span className="font-semibold text-coffee-dark">Roast Development</span>
                  <span className="text-sm text-gray-600">Profile creation tailored to origin characteristics.</span>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-2">
              <img src="https://api.iconify.design/lucide-info.svg?color=%235C3A21" alt="Info icon" className="w-5 h-5"/>
              <span className="text-sm text-gray-600">We publish traceability data with each lot.</span>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="rounded-xl overflow-hidden shadow-sm">
              <img loading="lazy" src="/images/B69A1426.jpg" alt="Raised bed drying" className="w-full h-60 object-cover"/>
            </div>
            <div className="rounded-xl overflow-hidden shadow-sm">
              <img loading="lazy" src="/images/B69A1559.jpg" alt="Coffee cherries" className="w-full h-60 object-cover"/>
            </div>
            <div className="rounded-xl overflow-hidden shadow-sm">
              <img loading="lazy" src="https://app.grapesjs.com/api/assets/random-image?query=%22coffee%20drying%22&w=800&h=600" alt="Quality control lab" className="w-full h-60 object-cover"/>
            </div>
            <div className="rounded-xl overflow-hidden shadow-sm">
              <img loading="lazy" src="/images/Coffee-tours.webp" alt="Roastery equipment" className="w-full h-60 object-cover"/>
            </div>
          </div>
        </div>
      </section>

      {/* Global presence */}


      <section className="w-full bg-light py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-6">
        
        <div className="text-center mb-16">
            <h1 className="text-sm font-semibold uppercase tracking-widest text-gold-accent mb-3">
                Global Network
            </h1>
            <h2 className="font-serif text-4xl lg:text-5xl text-cream-light leading-tight tracking-tight">
                Connecting Uganda’s Finest Coffee to the World
            </h2>
            <p className="mt-4 max-w-3xl mx-auto text-base text-black-300">
                Funzo Coffee is proud to connect Ugandan coffee to the world. We work with strategic partners across continents to bring our exceptional beans to roasters and consumers globally.
            </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            
            <div className="bg-cream-light p-8 rounded-2xl shadow-xl transition duration-300 ease-in-out hover:shadow-2xl hover:scale-[1.02] border-t-4 border-gold-accent">
                <div className="flex justify-center mb-4">
                    <img src="https://api.iconify.design/lucide-globe-2.svg?color=%233C2F2F" alt="GCC Globe" className="w-10 h-10 text-coffee-dark"/>
                </div>
                <h3 className="font-serif text-2xl text-coffee-dark mb-2 text-center">
                    GCC Region
                </h3>
                <p className="text-sm text-gray-700 text-center">
                    UAE, Saudi Arabia, Qatar
                </p>
            </div>

            <div className="bg-cream-light p-8 rounded-2xl shadow-xl transition duration-300 ease-in-out hover:shadow-2xl hover:scale-[1.02] border-t-4 border-gold-accent">
                <div className="flex justify-center mb-4">
                    <img src="https://api.iconify.design/lucide-building-2.svg?color=%233C2F2F" alt="Europe Building" className="w-10 h-10 text-coffee-dark"/>
                </div>
                <h3 className="font-serif text-2xl text-coffee-dark mb-2 text-center">
                    Europe
                </h3>
                <p className="text-sm text-gray-700 text-center">
                    Switzerland, UK, Germany
                </p>
            </div>

            <div className="bg-cream-light p-8 rounded-2xl shadow-xl transition duration-300 ease-in-out hover:shadow-2xl hover:scale-[1.02] border-t-4 border-gold-accent">
                <div className="flex justify-center mb-4">
                    <img src="https://api.iconify.design/lucide-map-pin.svg?color=%233C2F2F" alt="North America Pin" className="w-10 h-10 text-coffee-dark"/>
                </div>
                <h3 className="font-serif text-2xl text-coffee-dark mb-2 text-center">
                    North America
                </h3>
                <p className="text-sm text-gray-700 text-center">
                    United States & Canada
                </p>
            </div>
            
            <div className="bg-cream-light p-8 rounded-2xl shadow-xl transition duration-300 ease-in-out hover:shadow-2xl hover:scale-[1.02] border-t-4 border-gold-accent">
                <div className="flex justify-center mb-4">
                    <img src="https://api.iconify.design/lucide-trending-up.svg?color=%233C2F2F" alt="Emerging Markets Trend" className="w-10 h-10 text-coffee-dark"/>
                </div>
                <h3 className="font-serif text-2xl text-coffee-dark mb-2 text-center">
                    Emerging Markets
                </h3>
                <p className="text-sm text-gray-700 text-center">
                    China and East Asia
                </p>
            </div>

        </div>

        <p className="mt-16 text-center text-sm text-black-400">
            Our strategic presence ensures quality delivery and consistent supply across all major time zones.
        </p>
        
    </div>
</section>

    {/* End of global presence */}


      
      {/* Contact Section */}
      <section id="contact" className="w-full bg-orange-50 border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="flex flex-col gap-5">
            <h2 className="font-serif text-4xl text-coffee-dark">Contact Funzo Coffee</h2>
            <p className="mt-2 text-sm text-gray-600">We welcome roasters, importers, cafés, and community partners. Let’s build value together.</p>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <img src="https://api.iconify.design/lucide-map-pin.svg?color=%235C3A21" alt="Map icon" className="w-5 h-5"/>
                <span className="text-base text-coffee-primary">UHMG Building, Ground Floor. Plot 20-21 Martyrs Crescent. <br></br> P.O Box 23866 <br></br>Nakawa Uganda</span>
              </div>
              <div className="flex items-center gap-3">
                <img src="https://api.iconify.design/lucide-mail.svg?color=%235C3A21" alt="Mail icon" className="w-5 h-5"/>
                <a href="mailto:hello@funzocoffee.ug" className="text-base text-coffee-primary hover:text-coffee-secondary">info@funzocoffee.com</a>
              </div>
              <div className="flex items-center gap-3">
                <img src="https://api.iconify.design/lucide-phone.svg?color=%235C3A21" alt="Phone icon" className="w-5 h-5"/>
                <a href="tel:+256700000000" className="text-base text-coffee-primary hover:text-coffee-secondary">+256 751 449 095</a>
              </div>
            </div>
            <div className="flex items-center gap-4 mt-2">
              <a href="#" className="inline-flex items-center gap-2 text-coffee-primary border border-gray-300 rounded-lg p-2 hover:text-coffee-secondary hover:border-coffee-secondary focus:outline-none focus:ring-2 focus:ring-coffee-accent">
                <img src="https://api.iconify.design/lucide-instagram.svg?color=%235C3A21" alt="Instagram" className="w-5 h-5"/>
                <span className="text-sm">Instagram</span>
              </a>
              <a href="#" className="inline-flex items-center gap-2 text-coffee-primary border border-gray-300 rounded-lg p-2 hover:text-coffee-secondary hover:border-coffee-secondary focus:outline-none focus:ring-2 focus:ring-coffee-accent">
                <img src="https://api.iconify.design/lucide-linkedin.svg?color=%235C3A21" alt="LinkedIn" className="w-5 h-5"/>
                <span className="text-sm">LinkedIn</span>
              </a>
              <a href="#" className="inline-flex items-center gap-2 text-coffee-primary border border-gray-300 rounded-lg p-2 hover:text-coffee-secondary hover:border-coffee-secondary focus:outline-none focus:ring-2 focus:ring-coffee-accent">
                <img src="https://api.iconify.design/lucide-twitter.svg?color=%235C3A21" alt="Twitter" className="w-5 h-5"/>
                <span className="text-sm">X/Twitter</span>
              </a>
            </div>
          </div>
          <div className="flex flex-col">
            <form onSubmit={handleSubmit} aria-label="Contact form" className="bg-white rounded-xl shadow-sm p-6 flex flex-col gap-5 border border-blue-200">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <label className="flex flex-col gap-2">
                  <span className="text-sm font-medium text-gray-700">Full Name</span>
                  <input
                    type="text"
                    name="fullName"
                    placeholder="Your name"
                    aria-label="Full Name"
                    value={formData.fullName}
                    onChange={handleChange}
                    className={`w-full p-3 border rounded-lg focus:outline-none focus:ring-2 ${
                      errors.fullName ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-coffee-accent'
                    }`}
                  />
                  {errors.fullName && <p className="text-red-500 text-xs mt-1">{errors.fullName}</p>}
                </label>
                <label className="flex flex-col gap-2">
                  <span className="text-sm font-medium text-gray-700">Email</span>
                  <input
                    type="email"
                    name="email"
                    placeholder="name@example.com"
                    aria-label="Email"
                    value={formData.email}
                    onChange={handleChange}
                    className={`w-full p-3 border rounded-lg focus:outline-none focus:ring-2 ${
                      errors.email ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-coffee-accent'
                    }`}
                  />
                  {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                </label>
              </div>
              <label className="flex flex-col gap-2">
                <span className="text-sm font-medium text-gray-700">Message</span>
                <textarea
                  name="message"
                  placeholder="Tell us about your needs"
                  aria-label="Message"
                  value={formData.message}
                  onChange={handleChange}
                  className={`w-full p-3 border rounded-lg min-h-[120px] text-base focus:outline-none focus:ring-2 ${
                    errors.message ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-coffee-accent'
                  }`}
                ></textarea>
                {errors.message && <p className="text-red-500 text-xs mt-1">{errors.message}</p>}
              </label>
              <fieldset className="flex flex-col gap-3 mt-2">
                <legend className="text-sm font-medium text-gray-600 mb-2">I’m interested in</legend>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <label className="flex items-center gap-3 cursor-pointer">
                    <input
                      type="checkbox"
                      name="interests"
                      value="green beans"
                      checked={formData.interests.includes('green beans')}
                      onChange={handleChange}
                      aria-label="Green beans"
                      className="sr-only peer"
                    />
                    <span className="w-5 h-5 border border-gray-300 rounded-md flex items-center justify-center peer-checked:bg-coffee-secondary peer-checked:border-coffee-secondary transition-colors duration-200">
                      <img src="https://api.iconify.design/lucide-check.svg?color=%23FFFFFF" alt="Selected" className="w-4 h-4 opacity-0 peer-checked:opacity-100"/>
                    </span>
                    <span className="text-sm text-gray-700">Green beans</span>
                  </label>
                  <label className="flex items-center gap-3 cursor-pointer">
                    <input
                      type="checkbox"
                      name="interests"
                      value="roasted coffee"
                      checked={formData.interests.includes('roasted coffee')}
                      onChange={handleChange}
                      aria-label="Roasted coffee"
                      className="sr-only peer"
                    />
                    <span className="w-5 h-5 border border-gray-300 rounded-md flex items-center justify-center peer-checked:bg-coffee-secondary peer-checked:border-coffee-secondary transition-colors duration-200">
                      <img src="https://api.iconify.design/lucide-check.svg?color=%23FFFFFF" alt="Selected" className="w-4 h-4 opacity-0 peer-checked:opacity-100"/>
                    </span>
                    <span className="text-sm text-gray-700">Roasted coffee</span>
                  </label>
                  <label className="flex items-center gap-3 cursor-pointer">
                    <input
                      type="checkbox"
                      name="interests"
                      value="community initiatives"
                      checked={formData.interests.includes('community initiatives')}
                      onChange={handleChange}
                      aria-label="Partnerships"
                      className="sr-only peer"
                    />
                    <span className="w-5 h-5 border border-gray-300 rounded-md flex items-center justify-center peer-checked:bg-coffee-secondary peer-checked:border-coffee-secondary transition-colors duration-200">
                      <img src="https://api.iconify.design/lucide-check.svg?color=%23FFFFFF" alt="Selected" className="w-4 h-4 opacity-0 peer-checked:opacity-100"/>
                    </span>
                    <span className="text-sm text-gray-700">Community initiatives</span>
                  </label>
                </div>
                {errors.interests && <p className="text-red-500 text-xs mt-1">{errors.interests}</p>}
              </fieldset>
              <button
                type="submit"
                disabled={isSubmitting}
                className="px-5 py-3 bg-coffee-primary text-white rounded-lg shadow-md transition-all duration-150 hover:bg-coffee-dark focus:outline-none focus:ring-2 focus:ring-coffee-accent mt-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
